export const diffModes = {
  replaced: 'replaced',
  new: 'new',
  deleted: 'deleted',
  renamed: 'renamed',
};

export const imageViewMode = {
  twoup: 'twoup',
  swipe: 'swipe',
  onion: 'onion',
};
